function footerInit () {
    const footerSignature = $('#footer .footer-bottom #signature')
    const footerRows = $('#footer .footer-rows')

    footerSignature.before(nexgenSignature());
    footerRows.append(paymentCompaniesElement());
}